import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=86f42ca4&scoped=true"
import script from "./GiftCard.vue?vue&type=script&lang=js"
export * from "./GiftCard.vue?vue&type=script&lang=js"
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=86f42ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f42ca4",
  null
  
)

export default component.exports